 $( document ).ready(function() {

  $('.slider_vertical2').slick({
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'ease-in-out',

        });
   $('.slider_vertical1').slick({
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'ease-in-out',
            fade: true,
    

        });
    $('.productbox-slider').slick({
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            draggable: false,
            prevArrow: "<button class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='15' height='12' viewBox='0 0 6.591 11.061'><path d='M0,10,5,5,0,0' transform='translate(6.061 10.53) rotate(180)' fill='none' stroke='#383838' stroke-width='1.5'></path></svg></button>",
  nextArrow:'<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 6.591 11.061"><path d="M0,10,5,5,0,0" transform="translate(0.53 0.53)" fill="none" stroke="#383838" stroke-width="1.5"></path></svg></button>',
  
            cssEase: 'ease-in-out',
            asNavFor: '.slider_vertical1 , .slider_vertical2 '
        });
   if ($("#quickview").css("display") == "block") {
            $("body").addClass("overflow-hidden");
               
            } else {    
                $("body").removeClass("overflow-hidden");
               
            }
  
   /***filter grid****/
//   'use strict';
   
   var headerHeight = $('header').outerHeight();
    var z = headerHeight + 20 ;
   var c, currentScrollTop = 0,
       navbar = $('.mob_nav');

   $(window).scroll(function () {
      var a = $(window).scrollTop();
      var b = navbar.height();
      currentScrollTop = a;
     
      if (c < currentScrollTop && a > b + b) {
        navbar.removeClass("sticky_mobile_nav");
         $(".custom_filter .stickystick ").css("top", "20px");
        
      } else if (c > currentScrollTop && !(a <= b)) {
        navbar.addClass("sticky_mobile_nav");
         $(".custom_filter .stickystick").css("top", z);
         
      }
      c = currentScrollTop;
     
  });
  

   
  });

 /*scrolling img*/

 document.addEventListener("DOMContentLoaded", function() {
 gsap.registerPlugin(ScrollTrigger)

 let container = document.getElementById("container");
 let scrollContainer = document.getElementById("scroll-container");

  // 4900 is total width of all images
   const X = 2400 - container.offsetWidth

   let tl = gsap.timeline({
     scrollTrigger: {
           trigger: scrollContainer,
           scrub: true,
           start:"top top",
           end: "+=2400",
           pin: true,
           toggleClass: "pinned",
           toggleActions: "restart play none pause",
//        id:"#scrollContainer",
//        onLeave: function (self) {
//     self.scroll(self.start); // <-- sets position to start of ScrollTrigger
//     self.disable();
//     self.animation.progress(1);
//   }
         }
   })

    gsap.utils.toArray('.module').forEach((el, i) => {
     tl.fromTo(el,{x: 0}, { x: `-=${X}`, autoAlpha: 1, duration: 0.1}, "-=0.1")
   });
    

 });
